
import React from 'react';
import { useSelector } from 'react-redux';

function SummaryCards() {
  const { loading, summaryStrip } = useSelector((state) => state.stockDashboard);

  if (loading) {
    return <p>Loading...</p>;
  }

  const sKUsStockValue = summaryStrip?.skusInStock?.value || 0
  const stockValue = summaryStrip?.stockValue?.value || 0
  const nearExpiry = summaryStrip?.nearExpiry?.value || 0
  const lowStock = summaryStrip?.lowStock?.value || 0

  const cards = [
    { title: 'SKUs in Stock', value: sKUsStockValue },
    { title: 'Stock Value (₹)', value: stockValue },
    { title: 'Near Expiry', value: nearExpiry },
    { title: 'Low Stock', value: lowStock },
  ];

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      {cards?.map((card, i) => (
        <div
          key={i}
          style={{
            padding: '1px 20px 20px 20px',
            background: '#e9f2ff',
            borderRadius: '16px',
            flex: 1,
          }}
        >
          <h4>{card?.title}</h4>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ margin: 0 }}>{Number(card?.value).toFixed(card?.title === 'Stock Value (₹)' ? 2 : 0)}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;
